<template>
  <div class="select-country">
    <Modal v-if="open" ref="countryModal" class="mk-modal mk-modal-country without-close-btn" @close="close">
      <slot>
        <div class="tab">
          <a :class="{'active': tabIndex===1}" herf="#" @click="tabIndex=1">
            {{ locateCountry }}
          </a>
          <a :class="{'active': tabIndex===2}" herf="#" @click="tabIndex=2">
            {{ $t('CONCERT.GLOBAL') }}
          </a>
          <span :class="{'active': tabIndex===2}" class="tab-line" />
        </div>
        <div class="tab-content">
          <div v-if="tabIndex===2" class="breadcrumbs">
            <a v-for="(breadcrumb, index) in contentLayerBreadcrumbs" :key="index"
               @click="contentLayer = breadcrumb.type"
            >
              {{ breadcrumb.name }}
            </a>
          </div>
          <div class="content">
            <ul :class="{'active': tabIndex===1}">
              <li v-for="(country, index) in countryList[0]" :key="index">
                <a herf="#"
                   :class="{'disabled': country.event_count === 0}"
                   @click="update(false, displayCountryName(country), country.id)"
                >
                  {{ displayCountryName(country) }}
                  <span v-if="country.event_count > -1" class="num">
                    {{ country.event_count }}
                  </span>
                </a>
              </li>
            </ul>
            <ul ref="contentSlider" :class="{'active': tabIndex===2}" class="has-breadcrumbs">
              <div v-if="contentLayer === 'root'" class="content-container">
                <div v-if="countryList[1].continent" class="content-container">
                  <li v-for="continent in countryList[1].continent" :key="continent.id">
                    <a herf="#" @click="updateCountrySearch('continent', continent.id, continent.langs && continent.langs[0].name, 1)">
                      {{ continent.langs && continent.langs[0].name }}
                    </a>
                  </li>
                </div>
                <div v-else class="loader-container">
                  <Loader />
                </div>
              </div>
              <div v-else-if="contentLayer === 'continent'" class="content-container">
                <div v-if="countryList[1].countries" class="content-container">
                  <li v-for="country in countryList[1].countries" :key="country.id">
                    <a herf="#"
                       :class="{'disabled': country.event_count === 0}"
                       @click="updateCountrySearch('country', country.id, country.langs && country.langs[0].name, 2, country.state_count)"
                    >
                      {{ country.langs && country.langs[0].name }}
                      <span v-if="country.event_count > -1" class="num">
                        {{ country.event_count }}
                      </span>
                    </a>
                  </li>
                </div>
                <div v-else class="loader-container">
                  <Loader />
                </div>
              </div>
              <div v-else-if="contentLayer === 'country'" class="content-container">
                <div v-if="countryList[1].states" class="content-container">
                  <li v-for="municipality in countryList[1].municipalities" :key="municipality.id">
                    <a herf="#"
                       :class="{'disabled': municipality.event_count === 0, 'city': true}"
                       @click="update(true, municipality.langs && municipality.langs[0].name, municipality.id)"
                    >
                      {{ municipality.langs && municipality.langs[0].name }}
                      <span v-if="municipality.event_count > -1" class="num">
                        {{ municipality.event_count }}
                      </span>
                    </a>
                  </li>
                  <li v-for="state in countryList[1].states" :key="state.id">
                    <a herf="#"
                       :class="{'disabled': state.event_count === 0}"
                       @click="updateCountrySearch('state', state.id, state.langs && state.langs[0].name, 3)"
                    >
                      {{ state.langs && state.langs[0].name }}
                      <span v-if="state.event_count > -1" class="num">
                        {{ state.event_count }}
                      </span>
                    </a>
                  </li>
                </div>
                <div v-else class="loader-container">
                  <Loader />
                </div>
              </div>
              <div v-else-if="contentLayer === 'state'" class="content-container">
                <div v-if="countryList[1].cities" class="content-container">
                  <li v-for="city in countryList[1].cities" :key="city.id">
                    <a herf="#"
                       :class="{'disabled': city.event_count === 0, 'city': true}"
                       @click="update(false, city.langs && city.langs[0].name, city.id)"
                    >
                      {{ city.langs && city.langs[0].name }}
                      <span v-if="city.event_count > -1" class="num">
                        {{ city.event_count }}
                      </span>
                    </a>
                  </li>
                </div>
                <div v-else class="loader-container">
                  <Loader />
                </div>
              </div>
            </ul>
          </div>
        </div>
      </slot>
    </Modal>
  </div>
</template>

<script>
import Modal from '@/components/common/Modal'
import Loader from '@/components/common/Loader'

export default {
  name: 'ConcertCountryModal',
  components: {
    Modal,
    Loader
  },
  props: {
    open: {
      type: Boolean,
      default: false
    },
    countryList: {
      type: Array,
      default: () => []
    },
    locateCountry: {
      type: String,
      default: ''
    },
    globalSearchLayer: {
      type: String,
      default: ''
    },
    globalSearchBreadcrumbs: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      tabIndex: 1,
      contentLayer: 'root',
      contentLayerBreadcrumbs: [{ name: this.$t('CONCERT.GLOBAL'), type: 'root' }]
    }
  },
  computed: {
    locale() {
      return this.$i18n.locale
    }
  },
  watch: {
    locale(newLocale, oldLocale) {
      if (newLocale !== oldLocale) {
        this.init()
      }
    },
    countryList(newLocale, oldLocale) {
      if (newLocale[1].countries === undefined) {
        this.init()
      }
    },
    globalSearchLayer(newValue) {
      if (newValue) {
        this.contentLayer = newValue
      }
    },
    globalSearchBreadcrumbs(newValue) {
      if (newValue) {
        this.contentLayerBreadcrumbs = newValue
      }
    }
  },
  created() {
  },
  mounted() {
  },
  methods: {
    close() {
      this.$emit('close')
    },
    update(isMunicipality, label, val) {
      // console.log('update', label, val)
      if (isMunicipality) {
        this.contentLayerBreadcrumbs = this.contentLayerBreadcrumbs.slice(0, 3)
      }
      this.$emit('update-country-search', 'city', val, '', isMunicipality)
      this.$emit('update-val', 'country', label, val)
      this.$emit('close')
    },
    init() {
      this.tabIndex = 1
      this.contentLayer = this.globalSearchLayer || 'root'
      this.contentLayerBreadcrumbs = this.globalSearchBreadcrumbs || [{ name: this.$t('CONCERT.GLOBAL'), type: 'root' }]
    },
    updateCountrySearch(type, val, name, layer, hasStates, isMunicipality) {
      this.$set(this.$refs.contentSlider, 'scrollLeft', 0) // for safari
      this.$emit('update-country-search', type, val, hasStates, isMunicipality)
      // some country without state
      this.contentLayer = (hasStates !== undefined && hasStates === 0) ? 'state' : type
      this.contentLayerBreadcrumbs[layer] = { name: name, type: this.contentLayer }
      this.contentLayerBreadcrumbs = this.contentLayerBreadcrumbs.slice(0, layer + 1)
    },
    displayCountryName(item, localeParam) {
      const locale = (localeParam || this.$i18n.locale).toLowerCase()
      if (item && item.langs) {
        const langsAry = item.langs
        let matchedLangObj = langsAry.find(item => item.locale.toLowerCase() === locale)
        // fallback if no current locale and no english
        // if (!matchedLangObj && item.langs && item.langs.length > 0) {
        //   matchedLangObj = langsAry.find(item => item.locale.toLowerCase() === 'en-us')
        // }
        if (!matchedLangObj) {
          matchedLangObj = langsAry[0]
        }
        return (matchedLangObj && matchedLangObj.name) || ''
      }
      return ''
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/assets/scss/variables.scss';

.content-container{
  display: contents;
}

.mk-modal-country{
  .tab{
    position: relative;
    a{
      display: inline-block;
      width: 50%;
      height: 60px;
      float: left;
      font-size: 16px;
      font-weight: bold;
      line-height: 60px;
      color: $grey-9b;
      cursor: pointer;
      transition: .4s color cubic-bezier(0.165, 0.84, 0.44, 1);
      &.active{
        color: $grey-50;
      }
      &:not(.active) {
        background-color: #f3f3f3;
      }
    }
    .tab-line{
      position: absolute;
      width: 50%;
      height: 3px;
      bottom: 0;
      left: 0;
      background: $theme-red;
      transition: .4s left cubic-bezier(0.165, 0.84, 0.44, 1);
      &.active{
        left: 50%;
      }
    }
    &:after{
      content: "";
      display: block;
      clear: both;
    }
  }
  .breadcrumbs{
    margin: 24px 0 0;
    text-align: left;
    padding: 0 36px;
    a{
      display: inline-block;
      float: left;
      font-size: 16px;
      font-weight: bold;
      line-height: 1.63;
      color: $grey-9b;
      cursor: pointer;
      &:after{
        content: "navigate_next";
        display: inline-block;
        width: 20px;
        font-family: "Material Icons";
        font-size: 20px;
        font-weight: normal;
        vertical-align: middle;
        position: relative;
        margin: -3px 8px 0;
        cursor: default;
      }
      &:last-child:after{
        display: none;
      }
    }
    &:after{
      content: "";
      display: block;
      clear: both;
    }
  }
  .content{
    text-align: left;
    position: relative;
    ul{
      flex-flow: column wrap;
      -webkit-flex-flow: column wrap;
      column-count: 3;
      -webkit-column-count: 3;
      width: 100%;
      height: 350px;
      margin: 0;
      padding: 8px 0 0 36px;
      list-style: none;
      opacity: 0;
      display: none;
      li{
        display: inline-flex;
        display: -webkit-inline-flex;
        width: 33.33%;
        margin: 8px 0;
        a{
          display: inline-block;
          width: auto;
          height: 40px;
          font-size: 18px;
          font-weight: normal;
          line-height: 40px;
          color: $grey-7d;
          cursor: pointer;
          .num{
            font-size: 16px;
            font-weight: bold;
            color: $grey-9b;
            margin-left: 8px;
          }
          &.disabled{
            pointer-events: none;
            color: $grey-9b;
            opacity: .8;
            .num{
              color: $grey-9b;
            }
          }
        }
      }
      &.active{
        opacity: 1;
        display: flex;
        overflow-x: auto;
      }
    }
  }
  .loader-container{
    text-align: center;
    .loader{
      margin: 40px 0;
    }
  }
}

@media only screen and (max-width: 767.98px) {
  .mk-modal-country{
    .tab{
      position: relative;
      background: #fff;
      z-index: 1;
    }
    .breadcrumbs{
      position: relative;
      padding: 24px 24px 0;
      margin: 0;
      background: #fff;
      z-index: 1;
    }
    .tab-content{
      display: block;
      position: fixed;
      width: 100%;
      height: 100%;
      max-height: 100%;
      padding-top: 108px;
      top: 0;
    }
    .content{
      position: relative;
      width: 100%;
      max-height: 100%;
      height: 100%;
      ul{
        // display: block;
        padding: 10px 24px 0;
        column-count: auto;
        height: 100%;
        overflow-y: scroll;
        li{
          width: 100%;
          margin: 12px 0;
        }
        &.active{
          display: block;
        }
        &.has-breadcrumbs{
          padding-bottom: 60px;
        }
      }
    }
  }
}
</style>
<style lang="scss">
.modal-mask {
  &.mk-modal-country{
    .modal-container{
      overflow-y: hidden;
    }
  }
}
</style>
